<template>
  <section>
    <form method="post" @submit.prevent="onSend" novalidate>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title is-centered">
            {{ formTitle }}
          </p>
        </header>

        <section class="modal-card-body">
          <form-wrapper :validator="$v.form">
            <form-group
              horizontal
              name="continent"
              :label="$t('attributes.continent_name')"
            >
              <b-select
                v-model="form.continent_code"
                name="type"
                :placeholder="
                  $t('message.please_select') + $t('attributes.continent_name')
                "
                :disabled="isUpdate"
                expanded
              >
                <option v-for="c in continents" :value="c.code" :key="c.code">
                  {{ c.name }} {{ c.english_name }}
                </option>
              </b-select>
            </form-group>
            <form-group horizontal name="code" :label="$t('attributes.code')">
              <b-input
                v-model="form.code"
                name="code"
                maxlength="2"
                :has-counter="false"
                :disabled="isUpdate"
                :placeholder="
                  $t('message.please_input') + $t('attributes.code')
                "
                expanded
              >
              </b-input>
            </form-group>

            <form-group horizontal name="name" :label="$t('attributes.name')">
              <b-input
                v-model="form.name"
                name="name"
                :placeholder="
                  $t('message.please_input') + $t('attributes.name')
                "
                expanded
              >
              </b-input>
            </form-group>

            <form-group
              horizontal
              name="english_name"
              :label="$t('attributes.english_name')"
            >
              <b-input
                v-model="form.english_name"
                name="english_name"
                :placeholder="
                  $t('message.please_input') + $t('attributes.english_name')
                "
                expanded
              >
              </b-input>
            </form-group>

            <form-group
              horizontal
              name="flag"
              attribute="attributes.country_flag"
              :label="$t('attributes.country_flag')"
              grouped
            >
              <template #label>
                {{ $t('attributes.country_flag') }}
                <b-tooltip type="is-dark" label="30*30/限png,jpg檔，100KB內">
                  <b-icon
                    size="is-small"
                    type="is-danger"
                    icon="help-circle-outline"
                  ></b-icon>
                </b-tooltip>
              </template>
              <b-field class="file">
                <a class="button is-primary" @click="onSelectPictureImage">
                  <b-icon icon="upload"></b-icon>
                  <span>{{ $t('message.please_select_file') }}</span>
                </a>
                <figure v-if="form.flag" class="image">
                  <img
                    :src="countryTemplateFlagImage(form.flag)"
                    :alt="$t('attributes.flag')"
                    style="width: 30px; margin-left: 6px; margin-top: 5px;"
                  />
                </figure>
              </b-field>
            </form-group>
          </form-wrapper>
        </section>

        <footer class="modal-card-foot">
          <b-button
            :loading="isLoading"
            class="is-fullwidth"
            @click="$parent.close()"
          >
            {{ $t('attributes.close') }}
          </b-button>
          <b-button
            :loading="isLoading"
            type="is-primary"
            class="is-fullwidth"
            native-type="submit"
          >
            {{
              this.countryTemplate.code
                ? $t('attributes.update')
                : $t('attributes.add')
            }}
          </b-button>
        </footer>

        <b-loading :active.sync="isLoading" :can-cancel="false"></b-loading>
      </div>
    </form>
  </section>
</template>

<script>
import { required, maxLength, minLength } from 'vuelidate/lib/validators'
import { OpenCountryFlagFinder } from '@/utils/ckfinder'
import notifyService from '@/services/notifyService'
import { CONTINENT_API } from '@/utils/apis'

export default {
  name: 'CountryTemplateForm',

  props: {
    countryTemplate: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      sending: false,
      isUpdate: !!this.countryTemplate.code,
      continents: [],
      loadItems: false,
      form: this.extractFormValues(this.countryTemplate)
    }
  },
  validations: {
    form: {
      code: { required, minLength: minLength(2), maxLength: maxLength(2) },
      name: { required, maxLength: maxLength(50) },
      english_name: { required, maxLength: maxLength(150) },
      flag: { required },
      continent_code: { required },
      continent_name: {}
    }
  },
  computed: {
    formTitle() {
      let title = this.countryTemplate.code
        ? this.$t('attributes.modify')
        : this.$t('attributes.add')

      title += this.$t('attributes.country_template')

      return title
    },
    isLoading() {
      return this.sending
    }
  },
  mounted() {
    this.loadContinents()
  },
  methods: {
    extractFormValues(data) {
      return {
        code: data.code && data.code.trim(),
        name: data.name && data.name.trim(),
        english_name: data.english_name && data.english_name.trim(),
        flag: data.flag && data.flag.trim(),
        continent_code: data.continent_code,
        continent_name: data.continent_name
      }
    },
    async loadContinents() {
      try {
        const api = `${CONTINENT_API}`
        this.loadingItems = true
        const res = await this.axios.get(api)
        this.continents = res.data.data
      } catch (e) {
        this.continents = []

        notifyService.fetch_error('continent', e)
      } finally {
        this.loadingItems = false
      }
    },
    async onSelectPictureImage() {
      try {
        this.form.flag = await OpenCountryFlagFinder()
      } catch (e) {
        notifyService.error(e)
      }
    },
    async onSend() {
      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }

      this.$emit('send', this.form)
    }
  }
}
</script>
